module.exports = __webpack_public_path__ + "static/img/801bg.b77b5857.png";